export enum CodeName {
  // Citations programmatic page -- represents the dynamic Keyword value in its singular form prefixed with indefinite article (i.e. "a biography", "a Youtube video")
  KeywordSingularIndefinite = 'keyword_singular_indefinite',
  // Citations programmatic page -- represents the dynamic Keyword value in its title-cased, singular form prefixed with indefinite article (i.e. "a Biography", "a Youtube Video")
  KeywordSingularIndefiniteTitleCased = 'keyword_singular_indefinite_titlecased',
  // Citations programmatic page -- represents the dynamic Keyword value in its sentence-cased, singular form prefixed with indefinite article. Used at the start of a sentence (i.e. "A biography", "A Youtube video")
  KeywordSingularIndefiniteSentenceCased = 'keyword_singular_indefinite_sentencecased',
  // Citations programmatic page -- represents the dynamic Keyword value in its singular form prefixed with definite article (i.e. "the biography", "the Youtube video")
  KeywordSingularDefinite = 'keyword_singular_definite',
  // Citations programmatic page -- represents the dynamic Keyword value in its plural, indefinite form (i.e. "biographies", "Youtube videos")
  KeywordPluralIndefinite = 'keyword_plural_indefinite',
  // Citations programmatic page -- represents the dynamic Source Type value as is (i.e. "Book", "Wikipedia")
  SourceType = 'source_type',
  // Citations programmatic page -- represents the dynamic Source Type value in its singular form prefixed with indefinite article (i.e. "a book", "Wikipedia")
  SourceTypeSingularIndefinite = 'source_type_singular_indefinite',
  // Citations programmatic page -- represents the dynamic Style Guide value (i.e. "MLA", "APA")
  StyleGuide = 'style_guide',
  // Citation programmatic page -- represents the name of the bibliography page based on style guide (i.e. "References", "Bibliography", "Works Cited")
  BibliographyPageName = 'bibliography_page_name',
  // Citations programmatic page -- the generated full citation Template given style guide and source type
  FullCitationTemplate = 'full_citation_template',
  // Citations programmatic page -- the generated in-text citation Template given style guide and source type
  InTextCitationTemplate = 'in_text_citation_template',
  // Citations programmatic page -- the static narrative citation Template
  NarrativeCitationTemplate = 'narrative_citation_template',
  // Icon -- GGO Improve Icon for text
  GGOImproveIcon = 'ggo_improve_icon',
  // List Item Icon - Checkmark
  ListItemIconCheckMark = 'list_item_icon_checkmark',
  // Citations programmatic page - automated interlinking
  CitationAutomatedLinksCol1 = 'citations_automated_links_col1',
  CitationAutomatedLinksCol2 = 'citations_automated_links_col2',
  CitationAutomatedLinksCol3 = 'citations_automated_links_col3',
  TableHeader = 'table_header',
}

const citationProgrammaticPageShortcodes = [
  CodeName.KeywordSingularIndefinite,
  CodeName.KeywordSingularIndefiniteTitleCased,
  CodeName.KeywordSingularIndefiniteSentenceCased,
  CodeName.KeywordSingularDefinite,
  CodeName.KeywordPluralIndefinite,
  CodeName.SourceType,
  CodeName.SourceTypeSingularIndefinite,
  CodeName.StyleGuide,
  CodeName.BibliographyPageName,
  CodeName.FullCitationTemplate,
  CodeName.InTextCitationTemplate,
  CodeName.NarrativeCitationTemplate,
  CodeName.CitationAutomatedLinksCol1,
  CodeName.CitationAutomatedLinksCol2,
  CodeName.CitationAutomatedLinksCol3,
]

const inlineIconShortcodes = [CodeName.GGOImproveIcon, CodeName.ListItemIconCheckMark]

export type CitationProgrammaticPageShortcodeName = (typeof citationProgrammaticPageShortcodes)[number]

export type InlineIconShortcodeName = (typeof inlineIconShortcodes)[number]

export function isCitationProgrammaticPageShortcodeName(
  codeName: CodeName
): codeName is CitationProgrammaticPageShortcodeName {
  return citationProgrammaticPageShortcodes.indexOf(codeName) >= 0
}

export function isInlineIconCodeName(codeName: CodeName): codeName is InlineIconShortcodeName {
  return inlineIconShortcodes.indexOf(codeName) >= 0
}

export function isTableHeaderShortcodeName(codeName: CodeName): codeName is CodeName.TableHeader {
  return codeName === CodeName.TableHeader
}
